import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBadges } from './components/TrustBadges';
import { ExpertCare } from './components/ExpertCare';
import { AboutSection } from './components/AboutSection';
import { WhatWeDo } from './components/WhatWeDo';
import { Testimonials } from './components/Testimonials';
import { CTAStrip } from './components/CTAStrip';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-black selection:bg-taupe selection:text-black" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBadges data-id="element-4" />
        <ExpertCare data-id="element-5" />
        <AboutSection data-id="element-6" />
        <WhatWeDo data-id="element-7" />
        <Testimonials data-id="element-8" />
        <CTAStrip data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
    </div>;
}